<div fxLayout="column" style="padding: 20px">
    <div fxLayout="row" style="margin-top: 20px;">
        <span style="font-family: 'Century Gothic', sans-serif; font-size: 20px; font-weight: bold">Ιδιότητες δήλωσης</span>
    </div>

 <div style="margin-top: 50px">
    <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow" style="margin-bottom: 15px;">
        <span class="infoHeader" fxFlex="45">Δημιουργήθηκε από:</span>
<!--        <span class="infoDescription" fxFlex="35">{{form.createdByFirstName}} {{form.createdByLastName}}</span>-->
        <span class="infoDescription" fxFlex="35">{{form.created.firstName}} {{form.created.lastName}}</span>
    </div>
    <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow" style="margin-bottom: 15px;">
        <span class="infoHeader" fxFlex="45">Δημιουργήθηκε στις:</span>
<!--        <span class="infoDescription" fxFlex="35">{{form.date_created}}</span>-->
        <span class="infoDescription" fxFlex="35">{{form.created.created_at}}</span>
    </div>

<!--    <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow" style="margin-bottom: 15px;">-->
<!--        <span class="infoHeader" fxFlex="45">Δημοσιευμένη:</span>-->
<!--        <span class="infoDescription" fxFlex="35">{{form.isPublished ? 'ΝΑΙ' : 'OXI'}}</span>-->
<!--    </div>-->

    <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow" style="margin-bottom: 15px;">
        <span class="infoHeader" fxFlex="45">Ορατότητα:</span>
        <span class="infoDescription" fxFlex="35"><a style="color: var(--primary); text-decoration: underline" (click)="navigateToStudentList(form)">Λίστα χρηστών</a></span>
    </div>

    <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow" style="margin-bottom: 15px;">
        <span class="infoHeader" fxFlex="45">Ενημερώθηκε από:</span>
<!--        <span *ngIf="form.firstName" class="infoDescription" fxFlex="35">{{form.firstName}} {{form.lastName}}</span>-->
<!--        <span *ngIf="!form.firstName" class="infoDescription" fxFlex="35">-</span>-->
        <span *ngIf="form.modified.firstName" class="infoDescription" fxFlex="35">{{form.modified.firstName}} {{form.modified.lastName}}</span>
        <span *ngIf="!form.modified.firstName" class="infoDescription" fxFlex="35">-</span>
    </div>
    <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow" style="margin-bottom: 15px;">
        <span class="infoHeader" fxFlex="45">Ενημερώθηκε στις:</span>
<!--        <span class="infoDescription"-->
<!--              fxFlex="35">{{form.date_modified ? form.date_modified : '-'}}</span> -->

        <span class="infoDescription"
              fxFlex="35">{{form.modified.modified_at ? form.modified.modified_at : '-'}}</span>
    </div>
 </div>

</div>
